<wchfs-icon svgIcon="pso:info_m" size="24" (click)="onClick($event)"></wchfs-icon>
